<template>
  <dl class="input-block">
    <dt>予約方法</dt>
    <dd>
      <SelectBox class="select--method" required v-model.number="_value" :disabled="isDisabled" :items="typeMap">
        <template #icon><AssignIcon /></template>
      </SelectBox>
    </dd>
  </dl>
</template>

<script>
import { mapState } from 'vuex'
import { pick } from 'lodash'
import SelectBox from '@/components/atoms/SelectBox'
import typeMap, { getTypeMapBySyncType } from '@/resources/reservation/typeMap'
import { syncFromGnaviDaicho } from '@/resources/reservation/syncTypeMap'
import AssignIcon from '@/components/icons/assign'

export default {
  name: 'ReservationTypeInput',
  components: {
    SelectBox,
    AssignIcon,
  },
  computed: {
    ...mapState({
      type: state => state.reserves.edit.reservation.type,
      syncType: state => state.reserves.edit.reservation.syncType,
    }),
    _value: {
      get() {
        return this.type || ''
      },
      set(value) {
        this.$store.commit('reserves/edit/update', { type: +value })
      },
    },
    typeMap() {
      let type = getTypeMapBySyncType(this.syncType)
      if ([7, 8, 9, 10].includes(this.type)) {
        type = pick(typeMap, [this.type])
      }
      return type
    },
    isDisabled() {
      return !!this.syncType && !syncFromGnaviDaicho[this.syncType]
    },
  },
}
</script>

<style lang="postcss" scoped>
.select--method {
  margin-top: 8px;
  width: 224px;
}
</style>
